import { render, staticRenderFns } from "./Headbar.vue?vue&type=template&id=6827a130&scoped=true&"
import script from "./Headbar.vue?vue&type=script&lang=js&"
export * from "./Headbar.vue?vue&type=script&lang=js&"
import style0 from "./Headbar.vue?vue&type=style&index=0&id=6827a130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6827a130",
  null
  
)

export default component.exports